<template>
	<div class='file_upload_input'  :style="{width:c_wid+'px'}" @change='upload'>
		<div>

			<p>{{words}}</p>
			<a>{{BtnText}}</a>
		</div>

	</div>
	
</template>

<script>
export default {
	data (){
		return {
			upload_remind_words:'Resume ＊（.doc/.docx/.pdf format within 2MB）',
			BtnText:'upload'
		}
	},
	props: {
		init_width: String,
		words:String
	},
	computed :{
		c_wid: function() {
			return this.init_width ? this.init_width :475
		}
	},
	methods:{
		upload(e){
			let file=e.target.files[0]
			let formData= new FormData()
			formData.append('file', file)
			console.log(file,formData)
			if(file){
				/*if(this.maxSize){
					alert('size incorrect.')
				}
				if(this.type){
					alert('type incorrect')
				}*/
				this.$http.post('/common/fillform/uploadResume',formData)
				.then(function(d){
					console.log('success:'+d)
				},function(d){
					console.log('error'+d)
				})
			}
		}
	},
	watch:{
		words:function(){

		}
	}
}
</script>

<style lang='less'>
.file_upload_input{
	position: relative;
	display: inline-block;
	vertical-align: middle;
	box-sizing: border-box;
	width:475px;
	height:38px;
	border:1px solid #cccccc;
	border-radius: 10px;
	&>div{
		p{
			float: left;
			box-sizing: border-box;
			height:38px;
			line-height:38px;
			padding-left: 16px;
			width:80%;
			color:#999999;
			text-align:left;
			overflow: hidden;
		}
		a{
			float: right;
			position: relative;
			top:-1px;
			right:-1px;
			height:38px;
			width:20%;
			border-radius:0 10px 10px 0;
			background: #fcc800;
			font-size:14px;
			color:#1e1e1e;
			text-align: center;
			line-height:38px;
		}
	}
	input[type='file']{
		position: absolute;
		left:0;
		top:0;
		width:100%;
		margin: 0;
		opacity: 0;
		filter:alpha(opacity=0);
	}
}

</style>


// WEBPACK FOOTER //
// input_file.vue?99a2919c